import { useSelectClientesIntermedios } from "@/hooks/clientes-intermedios/useClientesIntermedios";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./select";

export function SelectClienteIntermedio({
  value,
  onChange,
}: {
  value: string;
  onChange: (idusuarioAlta: string) => void;
}) {
  const { data } = useSelectClientesIntermedios();
  const { options } = data || { options: [] };
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger>
        <SelectValue placeholder="Selecciona un intermediario" />
      </SelectTrigger>
      <SelectContent>
        {options.map((option, index) => (
          <SelectItem key={index} value={String(option.value)}>
            <span>{option.label}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

